import {Component, Input, OnInit} from '@angular/core';
import {FeaturedProductTileConfig} from '../../../models/featured-product';
import {FeaturedProductsService} from '../../../services/featured-products.service';

@Component({
  selector: 'app-featured-product-tile',
  templateUrl: './featured-product-tile.component.html'
})
export class FeaturedProductTileComponent implements OnInit {

  @Input() config: FeaturedProductTileConfig;
  url: string;

  constructor(private featuredProductsService: FeaturedProductsService) { }

  ngOnInit(): void {
    this.setUrl();
  }

  private setUrl(): void {
    this.url = this.featuredProductsService.getTileUrlWithParams(this.config.key);
  }

}
